module.exports = __webpack_public_path__ + "img/screenshot-5.ce42c7d6.png";